import React from "react";
import { TopRated } from "pages";

const TopRatedRoute = () => {
  return (
    <>
      <TopRated />
    </>
  );
};

export default TopRatedRoute;
